const getBaseUnit = unit => {
  const numberMatcher = String(unit).match(/[0-9]/g);
  if (numberMatcher && numberMatcher.length) {
    return unit;
  }

  const unitAsString = String(unit)
    .toLowerCase()
    .match(/[a-z]+/g);
  if (!unitAsString || unitAsString.length === 0) {
    return null;
  }

  switch (unitAsString[0]) {
    case "g": {
      return "Gramm";
    }
    case "gr": {
      return "Gramm";
    }
    case "gramm": {
      return "Gramm";
    }

    case "ml": {
      return "Mililiter";
    }
    case "mililiter": {
      return "Mililiter";
    }
    case "milliliter": {
      return "Mililiter";
    }

    case "kg": {
      return "Kilogramm";
    }
    case "kilo": {
      return "Kilogramm";
    }
    case "kilogramm": {
      return "Kilogramm";
    }

    case "l": {
      return "Liter";
    }
    case "liter": {
      return "Liter";
    }
    case "litre": {
      return "Liter";
    }
    case "ltr": {
      return "Liter";
    }
    case "lieter": {
      return "Liter";
    }

    default:
      return unit;
  }
};

export { getBaseUnit };
